// removed by extract-text-webpack-plugin
module.exports = {"buttonLink":"buttonLink___3BtGD","medium":"medium___QFaC5","small":"small___1e7H2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Buttons/LinkButton/index.scss
// module id = 76
// module chunks = 0